import { useState, useEffect } from 'react';
import { supabase } from '../services/supabase';
import { Database } from '../types/database';

type Review = Database['public']['Tables']['reviews']['Row'];

export const useReviews = (businessId: string) => {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchReviews = async () => {
    if (!businessId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const { data, error } = await supabase
        .from('reviews')
        .select(`
          *,
          user_profiles!reviews_customer_id_fkey (
            full_name,
            email
          )
        `)
        .eq('business_id', businessId)
        .eq('verified', true)
        .order('created_at', { ascending: false });

      if (error) {
        throw error;
      }

      setReviews(data || []);
    } catch (err: any) {
      console.error('Error fetching reviews:', err);
      setError(err.message || 'Failed to load reviews');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, [businessId]);

  return {
    reviews,
    loading,
    error,
    refetch: fetchReviews
  };
};